import { CommonData } from '../common_schema'

export const raftstoreData: CommonData[] = [
  {
    name: 'Storage async write duration(p99)',
    mean: 'P99_async_write_duration:total.values.mean',
    std: 'P99_async_write_duration:total.values.std',
    location: 'Performance Overview  --> Storage async write duration'
  },
  {
    name: 'Store duration(p99)',
    mean: 'P99_store_duration:total.values.mean',
    std: 'P99_store_duration:total.values.std',
    location: 'Performance Overview  --> Store duration'
  },
  {
    name: 'Apply duration(p99)',
    mean: 'P99_apply_duration:total.values.mean',
    std: 'P99_apply_duration:total.values.std',
    location: 'Performance Overview  --> Apply duration'
  },
  {
    name: 'Propose wait duration(p99)',
    mean: 'P99_propose_wait_duration:total.values.mean',
    std: 'P99_propose_wait_duration:total.values.std',
    location: 'TiKV-Details --> Raft Propose --> Propose wait duration'
  },
  {
    name: 'Commit log duration(p99)',
    mean: 'P99_commit_log_duration:total.values.mean',
    std: 'P99_commit_log_duration:total.values.std',
    location: 'TiKV-Details --> Raft IO  --> Commit Log duration'
  },
  {
    name: 'Append log duration(p99)',
    mean: 'P99_append_log_duration:total.values.mean',
    std: 'P99_append_log_duration:total.values.std',
    location: 'TiKV-Details --> Raft IO --> Append log duration per server'
  },
  {
    name: 'Apply wait duration(p99)',
    mean: 'P99_apply_wait_duration:total.values.mean',
    std: 'P99_apply_wait_duration:total.values.std',
    location: 'TiKV-Details --> Raft Propose --> Apply wait duration per server'
  },
  {
    name: 'Apply log duration(p99)',
    mean: 'P99_apply_log_duration:total.values.mean',
    std: 'P99_apply_log_duration:total.values.std',
    location: 'TiKV-Details --> Raft IO --> Apply log duration per server'
  }
]
